import React, { useState } from 'react';
import styled from 'styled-components';
import MaterialSlider from '@mui/material/Slider';
import { withStyles } from '@mui/styles';

import { INFO } from '../../../theme';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding-bottom: 6px;
`;

const MaterialSliderWithStyles = withStyles({
  root: {
    color: INFO,
  },
})(MaterialSlider);

const noop = () => {};

export const Slider = ({ value = 0, onChange = noop }) => {
  const [internalValue, setInternalValue] = useState(value);

  return (
    <Wrapper>
      <MaterialSliderWithStyles
        value={typeof internalValue === 'number' ? internalValue : 0}
        onChange={(e, v) => {
          setInternalValue(v);
          onChange(v);
        }}
        aria-labelledby="input-slider"
      />
      <span>
        &nbsp;
        {internalValue}%
      </span>
    </Wrapper>
  );
};
